import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRolesFromToken } from '../utils/auth';
import { ROLES } from '../utils/roles';
import TicketPrinter from '../components/TicketPrinter';

const HomePage = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('jwt');
    const roles = getRolesFromToken(token);
    const esPropietario = roles.includes(ROLES.PROPIETARIO);
    const esEmpleado = roles.includes(ROLES.EMPLEADO) || esPropietario;
    const [mostrarTicket, setMostrarTicket] = useState(false);

    if (mostrarTicket) {
        return (
            <div className="min-h-screen bg-gray-50 p-6">
                <TicketPrinter />
                <div className="max-w-lg mx-auto mt-4">
                    <button
                        className="w-full py-2.5 px-4 bg-gray-500 text-white text-sm font-medium rounded-md hover:bg-gray-600 transition-colors"
                        onClick={() => setMostrarTicket(false)}
                    >
                        Volver
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4">
            <div className="max-w-lg mx-auto bg-white rounded-lg shadow-sm border border-gray-200 p-8 space-y-4">
                {esPropietario && (
                    <div className="space-y-3">
                        <h3 className="text-lg font-semibold text-gray-900 text-center mb-4">Gestión de Propietario</h3>
                        <button className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors" onClick={() => navigate('/propietario/estadisticas')}>Estadísticas</button>
                        <button className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors" onClick={() => navigate('/propietario/registrar-empleado')}>Registrar Empleado</button>
                        <button className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors" onClick={() => navigate('/propietario/listar-empleados')}>Gestionar Empleados</button>
                        <button className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors" onClick={() => navigate('/propietario/entrada')}>Gestionar Entrada</button>
                    </div>
                )}

                {esEmpleado && (
                    <div className="space-y-3">
                        <h3 className="text-lg font-semibold text-gray-900 text-center mb-4">Gestión de Empleado</h3>
                        <button className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors" onClick={() => navigate('/personal/eventos')}>Eventos</button>
                        <button className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors" onClick={() => navigate('/personal/ticket')}>Registrar Entrada</button>
                        <button className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors" onClick={() => setMostrarTicket(true)}>Impresión Directa</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HomePage;
